import React, { memo } from 'react';

import { ReactComponent as EyeOpen } from 'assets/icons/EyeOpen.svg';

import { useAppSelector } from 'modules/state-mgmt/store';
import { piiFields } from 'constants/common';
import { useStyles } from './styles';

export interface IPiiFieldWrapperProps {
  children: React.ReactNode;
  styleClass?: string;
  piiFieldName?: string;
  label: string;
  required?: boolean;
  skippable?: boolean;
  onClick?: (e: React.MouseEvent) => void;
}

const PiiFieldWrapper = ({
  children,
  styleClass,
  piiFieldName,
  label,
  required,
  skippable,
  onClick,
}: IPiiFieldWrapperProps) => {
  const classes = useStyles();

  const {
    isOffline,
    isWorker,
    workerPIIPinInformation,
    piiFields,
    isWorkerCreated,
    isInRegistrationWizard,
    addEmployerFlow,
  } = useAppSelector(state => ({
    isOffline: !state.app.isOnline,
    isWorker: !state.user?.userId || state.user?.isWorker,
    workerPIIPinInformation: state.onboarding.workerPIIPinInformation,
    isWorkerCreated: state.onboarding?.id,
    isInRegistrationWizard: (state.onboarding?.temp?.visitedWizardSteps?.length ?? 0) > 0,
    addEmployerFlow: state.onboarding.temp?.addEmployerFlow || false,
    piiFields: {
      dateOfBirth: state.onboarding?.dateOfBirth,
      socialSecurityNumber: state.onboarding?.socialSecurityNumber,
      line1: state.onboarding?.address?.line1,
      line2: state.onboarding?.address?.line2,
      city: state.onboarding?.address?.city,
      state: state.onboarding?.address?.stateCode,
      zipCode: state.onboarding?.address?.zipCode,
      country: state.onboarding?.address?.country?.id,
      county: state.onboarding?.address?.county,
      borough: state.onboarding?.address?.borough,
    },
  }));

  const isVisible =
    (isOffline && !isWorker) ||
    (Object.hasOwn(piiFields, piiFieldName)
      ? workerPIIPinInformation?.isPIIVisible ||
        !piiFields[piiFieldName] ||
        !isWorkerCreated ||
        (isInRegistrationWizard && !addEmployerFlow)
      : true);

  return isVisible ? (
    <>{children}</>
  ) : (
    <div
      className={`${classes.root} ${styleClass}`}
      data-testid={piiFieldName ? `pii-masked-${piiFieldName}` : undefined}
      onClick={onClick}
    >
      <span className={classes.hiddenText}>*****</span>
      <div className={classes.label}>
        <span>{label}</span>
        {(required || skippable) && (
          <span className={required ? classes.requiredMark : classes.skippableMark}>{required ? '*' : '**'}</span>
        )}
      </div>
      <EyeOpen />
    </div>
  );
};

export default memo(PiiFieldWrapper);
